import { render, staticRenderFns } from "./MiniproLiveList.vue?vue&type=template&id=777b84c0&scoped=true"
import script from "./MiniproLiveList.vue?vue&type=script&lang=js"
export * from "./MiniproLiveList.vue?vue&type=script&lang=js"
import style0 from "./MiniproLiveList.vue?vue&type=style&index=0&id=777b84c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777b84c0",
  null
  
)

export default component.exports